import { uniqBy } from 'lodash';
import { getCommentsRepositoryPluginAdapter } from './CommentsRepositoryPluginAdapter';

export const formatCommentUsers = (users) =>
  users.map((_) => ({
    ..._,
    id: _.id.toString(),
    name: `${_.firstName} ${_.lastName}`,
  }));

export const getCommentsAdapter = (
  projectId,
  currentUser,
  comments,
  entityType,
  entityId,
  entityVersion,
  commentThreads,
  dispatch,
  formatThread,
  usersForCommenting = [],
  isEntitySharedWithClient = false
) => {
  return class {
    constructor(editor) {
      this.editor = editor;
    }

    init() {
      const usersPlugin = this.editor.plugins.get('Users');
      const commentsRepository = this.editor.plugins.get('CommentsRepository');

      // Load the users data.
      const allUserIds = usersForCommenting.map((_) => _.id);
      const nonExistentUsers = uniqBy(
        comments
          .filter((_) => !allUserIds.includes(_.authorId))
          .map((_) => ({
            id: _.authorId,
            firstName: 'Deleted',
            lastName: 'User',
          })),
        'id'
      );

      const commentUsers = formatCommentUsers([
        ...usersForCommenting,
        ...nonExistentUsers,
      ]);

      commentUsers.forEach((_) => usersPlugin.addUser(_));

      // Set the current user.
      usersPlugin.defineMe(currentUser.id.toString());

      // Set the adapter on the `CommentsRepository#adapter` property.
      commentsRepository.adapter = getCommentsRepositoryPluginAdapter(
        projectId,
        currentUser,
        comments,
        entityType,
        entityId,
        entityVersion,
        commentThreads,
        dispatch,
        formatThread,
        isEntitySharedWithClient
      );
    }
  };
};
